<section class="scr-page scr-page--compact">
  <div class="scr-card budget-card">
    <tp-page-header variant="toolbar" title="Presupuestos" [subtitle]="dataSource.filteredData.length + (dataSource.filteredData.length === 1 ? ' presupuesto' : ' presupuestos')">
      <div class="scr-search">
        <mat-icon class="scr-search__icon" aria-hidden="true">search</mat-icon>
        <input
          type="text"
          class="form-control"
          placeholder="Buscar presupuesto"
          aria-label="Buscar presupuesto"
          (keyup)="applyFilter($event)"
        />
      </div>
      <!-- The date panel hangs from its own button, so it opens right under it. -->
      <div class="date-filter-anchor">
        <button type="button" class="filter-button" (click)="toggleVisibility()" title="Abrir filtros">
          <img src="../assets/icons/filter/open-filter.svg" alt="" />
          Filtrar por fecha
        </button>
        <app-dates-filter
          [visibility]="isVisible"
          (sendDates)="setDates($event)"
          (clickOutside)="closeModal()"
        ></app-dates-filter>
      </div>
    </tp-page-header>
  <div class="table-container scr-table-scroll">
    <table
      mat-table
      [dataSource]="dataSource"
      matSort
      (matSortChange)="announceSortChange($event)"
    >
      <ng-container matColumnDef="budgetDate">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          sortActionDescription="Sort by budgetDate"
        >
          <span class="truncate">Fecha de presupuesto</span>
        </th>
        <td mat-cell *matCellDef="let element">
          <span class="data">{{ element.budgetDate | date : "dd/MM/yyyy" }}</span>
        </td>
      </ng-container>
      <ng-container matColumnDef="clientName">
        <th
          mat-header-cell
          *matHeaderCellDef
          class="align"
          mat-sort-header
          sortActionDescription="Sort by clientName"
        >
          <span class="truncate">Cliente</span>
        </th>
        <td mat-cell *matCellDef="let element">
          <span class="data">{{ element.clientName }}</span>
        </td>
      </ng-container>
      <ng-container matColumnDef="poolModel">
        <th mat-header-cell *matHeaderCellDef class="align">
          <span class="truncate">Modelo de piscina</span>
        </th>
        <td mat-cell *matCellDef="let element">
          <span class="data">{{ element.poolModel }}</span>
        </td>
      </ng-container>
      <ng-container matColumnDef="cashPrice">
        <th mat-header-cell *matHeaderCellDef class="align">
          <span class="truncate">Precio</span>
        </th>
        <td mat-cell *matCellDef="let element">
          <span class="data bl-amount">$ {{ element.cashPrice | number : "1.0-0" }}</span>
        </td>
      </ng-container>
      <ng-container matColumnDef="isFinished">
        <th mat-header-cell *matHeaderCellDef>
          <span class="truncate">Estado</span>
        </th>
        <td mat-cell *matCellDef="let element">
          <lebel
            class="scr-status w-auto"
            [ngClass]="element.isFinished ? 'scr-status--success' : 'scr-status--info'"
          >
            {{ element.isFinished ? "Finalizado" : "No finalizado" }}
          </lebel>
        </td>
      </ng-container>
      <ng-container matColumnDef="print">
        <th mat-header-cell *matHeaderCellDef class="bl-col-center">
          <span class="truncate">Imprimir</span>
        </th>
        <td
          mat-cell
          *matCellDef="let element"
          (click)="goBudgetDetail(element.id, element.isCompleted)"
          style="text-align: center"
        >
          <mat-icon
            class="cursor-pointer print"
            role="button"
            tabindex="0"
            [attr.aria-label]="(element.isCompleted ? 'Imprimir presupuesto de ' : 'Abrir presupuesto de ') + element.clientName"
            (keydown.enter)="goBudgetDetail(element.id, element.isCompleted)"
          >{{
            element.isCompleted ? "print" : "description"
          }}</mat-icon>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      <tr class="mat-mdc-row bl-empty-row" *matNoDataRow>
        <td class="mat-mdc-cell" [attr.colspan]="displayedColumns.length">
          <tp-empty-state
            icon="request_quote"
            [title]="dataSource.filter ? 'Sin resultados' : 'No hay presupuestos para mostrar'"
            [message]="dataSource.filter ? 'Probá con otra búsqueda.' : 'Los presupuestos que se generen para los clientes van a aparecer acá. Probá con otro rango de fechas.'"
          ></tp-empty-state>
        </td>
      </tr>
    </table>
  </div>
  <div class="scr-footer">
    <span class="scr-count">{{ dataSource.filteredData.length }} resultados</span>
    <mat-paginator
      [pageSizeOptions]="[10, 20, 30]"
      aria-label="Página del listado de presupuestos"
    ></mat-paginator>
  </div>
  </div>
</section>
